import { render } from "./RoleTreeModal.vue?vue&type=template&id=7eee6575&ts=true"
import script from "./RoleTreeModal.vue?vue&type=script&lang=ts"
export * from "./RoleTreeModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\PhuongVangDanh\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__